import gql from 'graphql-tag';

import { DepartmentFragment, DepartmentDataFragment } from './fragments/DepartmentFragment';

export const queryDepartmentsFromFaculty = gql`
  query GetFaculty($facId: Int!, $eduTag: String) {
    faculty(id: $facId) {
      id
      name
      logo
      departments(eduTag: $eduTag) {
        id
        ...DepartmentFragment
      }
      university {
        id
        name
      }
    }
  }
  ${DepartmentFragment}
`;

export const deptConverter = (department = {}, faculty = {}, university = {}) => ({
  id: department.id,
  university: university.name,
  faculty: faculty.name,
  department: department.name,
  rounds: department.roundSeats && department.roundSeats.map(r => r >= 0),
  image: department.logo,
  score: department.score ? department.score.min : null,
  scoreType: (department.score && department.score.scoreType) || null,
  likes: department.likes || null,
});

// Use for special EduTag (eg. Meds)
export const queryDepartmentsFromTag = gql`
  query GetDepartmentsFromTag($eduTag: String!) {
    departments(eduTag: $eduTag) {
      id
      ...DepartmentDataFragment
    }
  }
  ${DepartmentDataFragment}
`;
